"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _hooks = require("../../hooks");
var _TranslationsLoader = require("./TranslationsLoader");
var _intl = require("../../utils/intl");
var _locale = require("../../utils/locale");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TranslationProvider = props => {
  const {
    omitFetching = false,
    silent: isSilent = false,
    children
  } = props;
  const {
    locale
  } = (0, _hooks.useConfig)();
  if (omitFetching) {
    return /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, _extends({
      onError: _intl.handleTranslationError,
      locale: (0, _locale.getISOLocale)(locale)
    }, props), children);
  }
  return /*#__PURE__*/_react.default.createElement(_TranslationsLoader.TranslationsLoader, _extends({
    locale: locale,
    silent: isSilent
  }, props), children);
};
var _default = exports.default = TranslationProvider;